import { getConfigKeys } from '@/api/common';
import router from '@/router';
import useUserStore from '@/store/modules/user';
import { checkLoginAndRedirect } from '@/utils/checkLoginAndRedirect';
import { ElMessageBox } from 'element-plus';

// 后管地址配置
const PORTAL_URL_TEST = 'http://120.55.102.114:8608/data-space-web/'; // 测试环境
const key = 'sys_mng_url';
const getPortalUrl = () => {
  return new Promise((resolve) => {
    const hostname = window.location.hostname;
    if (hostname.startsWith('120.55.102.114')) {
      resolve(PORTAL_URL_TEST);
    } else {
      getConfigKeys(key).then((res) => {
        resolve(res.data[key]);
      });
    }
  });
};

/**
 * 处理跳转到后管系统的逻辑，包含用户身份校验和token有效性验证
 * @param path - 可选参数，指定跳转后需要定位的后管系统路径
 * @returns void
 */
export const useToMng = (path?: string) => {
  const fullPath = router?.currentRoute?.value?.fullPath || '/';

  const userStore = useUserStore();
  checkLoginAndRedirect({
    path: fullPath, // 占位路径，实际不跳转
    callback: () => {
      // 校验 token 是否失效
      useUserStore()
        .getInfo()
        .then(() => {
          // 获取门户系统URL并构建带认证信息的跳转地址
          getPortalUrl().then((portalUrl) => {
            let url = `${portalUrl}#/loginByToken?token=${userStore.token}`;
            if (path) {
              url = `${url}&path=${encodeURIComponent(path)}`;
            }
            // 在新窗口打开后管系统登录地址
            window.open(url, '_blank');
          });
        })
        .catch(() => {
          // token失效时跳转至登录页
          ElMessageBox.confirm('您当前登录信息已过期，请登录后继续操作', '', {
            confirmButtonText: '立即登录',
            cancelButtonText: '暂不登录',
            type: 'info',
            customClass: 'login-required-dialog',
            cancelButtonClass: 'login-cancel-button',
            confirmButtonClass: 'login-confirm-button',
            center: true,
            showClose: true,
          })
            .then(() => {
              router.push({
                path: '/login',
              });
            })
            .catch(() => {
              // 暂不登录，不做任何处理
            });
        });
    },
  });
};

export const useToMngForInvite = (token) => {
  getPortalUrl().then((portalUrl) => {
    window.open(`${portalUrl}#/loginByToken?token=${token}`, '_blank');
  });
};
